// extracted by mini-css-extract-plugin
export default {"wrapper":"switcher_wrapper__GQ+v2","wrapper-button":"switcher_wrapper-button__zlRdi","wrapper-button--active":"switcher_wrapper-button--active__BAWrU"};